import { getBrand } from '../utils/getBrand';
import { useFetchUrlCache } from '../utils/useFetchUrlCache';

export const getTranslationsJson = async () => {
  const translations = {};
  const promises = ['en', 'fr'].map((lang) => {
    const url = `configurations/i18n/${getBrand().name}/${lang}.json`;
    return useFetchUrlCache(url).then((data) => ({ lang, data }));
  });
  try {
    for await (const { lang, data } of promises) {
      translations[lang] = data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return translations;
};
